export default "__VITE_ASSET__8735594b__"